export enum Resource {
  AcceptSubmission = 'accept_submission',
  AccessClinicLocator = 'access_clinic_locator',
  AccessGrantData = 'access_grant_data',
  AccessMyGrants = 'access_my_grants',
  AccessReportingDashboard = 'access_reporting_dashboard',
  AccessSubrecipientData = 'access_subrecipient_data',
  AccessSystemAdmin = 'access_system_admin',
  AccessTableArchive = 'access_table_archive',
  ApproveFparData = 'approve_fpar_data',
  CreateNewAccount = 'create_new_account',
  CreateNewAllDataAnalyst = 'create_new_all_data_analyst',
  CreateNewDataCoordinator = 'create_new_data_coordinator',
  CreateNewGrantAdmin = 'create_new_grant_admin',
  CreateNewGrantDataAnalyst = 'create_new_grant_data_analyst',
  CreateNewGrantUser = 'create_new_grant_user',
  CreateNewProjectOfficer = 'create_new_project_officer',
  CreateNewReportingPeriod = 'create_new_reporting_period',
  CreateNewSubmissionComment = 'create_new_submission_comment',
  CreateNewSubrecipientDataAnalyst = 'create_new_subrecipient_data_analyst',
  CreateNewSubrecipientUser = 'create_new_subrecipient_user',
  CreateNewSystemSupportStaff = 'create_new_system_support_staff',
  DisableExistingAccount = 'disable_existing_account',
  EditAccountDetails = 'edit_account_details',
  EditComments = 'edit_comments',
  EditDataQualityIssue = 'edit_data_quality_issue',
  EditReportingPeriod = 'edit_reporting_period',
  EditSubmissionComment = 'edit_submission_comment',
  EditSupplementalInformation = 'edit_supplemental_information',
  EnterGrantContactInfo = 'enter_grant_contact_info',
  EnterGrantPerformanceMeasures = 'enter_grant_performance_measures',
  GenerateDashboardData = 'generate_dashboard_data',
  ListAssignableRoles = 'list_assignable_roles',
  ListGrants = 'list_grants',
  ListPermissions = 'list_permissions',
  ListUsers = 'list_users',
  ReceiveNewAccountNotification = 'receive_new_account_notification',
  RemoveAllUsers = 'remove_all_users',
  RemoveGrantAssociation = 'remove_grant_association',
  ResetPassword = 'reset_password',
  ReturnSubmission = 'return_submission',
  SubmitGrantForOpaReview = 'submit_grant_for_opa_review',
  UpdateGrantAttributes = 'update_grant_attributes',
  UpdateProfileCoverSheet = 'update_profile_cover_sheet',
  UpdateSubmissionStatus = 'update_submission_status',
  UploadEncounterData = 'upload_encounter_data',
  ValidateFparData = 'validate_fpar_data',
  ViewDashboardGrantSelector = 'view_dashboard_grant_selector',
  ViewDataStatusReport = 'view_data_status_report',
  ViewGrantPortal = 'view_grant_portal',
  ViewMyFparPage = 'view_my_fpar_page',
  ViewProfileCoverSheet = 'view_profile_cover_sheet',
  ViewRemovedUserReport = 'view_removed_user_report',
  ViewReviewPortal = 'view_review_portal',
  ViewSites = 'view_sites',
  ViewSubmissionReport = 'view_submission_report',
  ViewSubrecipients = 'view_subrecipients',
  ViewTableArchiveGrantSelector = 'view_table_archive_grant_selector',
  ViewValidationReport = 'view_validation_report',
}
